<template>
  <div id="sidebar" :class="{ 'hide': $store.state.Auth.isSidebarHide }">
    <div class="sideheader">
      <div class="logo">
        <img v-if="$store.state.Auth.isSidebarHide" class="logo2" src="../assets/image/suzuya.png" />
        <img v-else class="logo1" src="../assets/image/LogoSuzuya.png" />
      </div>
      <div class="closeSidebar" @click="$store.dispatch('Auth/toggleSidebar')">
        <i class="fa fa-times" aria-hidden="true"></i>
      </div>
    </div>
    <ul class="side-menu">
      <li v-for="(n, i) in menu" :key="i" >
        <!-- <template>
          <li class="dividers" data-text="main">Main</li>
        </template> -->
        <router-link
          v-if="n.drop == 0"
          :to="n.url"
          :class="{ 'menu-active': isMenuActive(n.url) }" 
          ><i class="icon-left" :class="n.icon"></i>{{ n.name }}</router-link
        >
        <a v-if="n.drop == 1" :class="{ 'menu-active': isMenuActive(n.url)}" @click="toggleDropdown(i)"
          ><i class="icon-left" :class="n.icon"></i>{{ n.name }}
          <i class="fas fa-chevron-down icon-right"></i
        ></a>
        <ul
          v-if="n.drop == 1"
          class="side-dropdown"
          :class="{ show: activeDropdown === i }"
        >
          <li v-for="(s, x) in n.submenu" :key="x" @click="readAll(x, s.url)">
            <router-link
              :to="s.url"
              :class="{
                'side-active ': isSideActive(s.url),
                '': false,
              }"
              ><i
                class="icon-left-side far fa-circle"
                :class="{
                  'fas fa-circle ': isSideActive(s.url),
                  '': false,
                }"
              ></i
              >{{ s.name }}
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
import { getPage } from "@/utils/HandleToken";
export default {
  data() {
    return {
      invActive: null,
      activeDropdown: null, // Menyimpan indeks dropdown yang aktif
    };
  },
  computed: {
    menu() {
      return this.$store.state.Auth.menuData;
    },
  },
  created() {
    this.setActiveDropdownOnLoad();
  },
  methods: {
    isMenuActive(url) { 
      this.setActiveDropdownOnLoad();
      return this.$route.path === url
    },
    isSideActive(url) {
      return this.$route.path === url;
    },
    toggleDropdown(index) {
      this.activeDropdown = this.activeDropdown === index ? null : index;
    },
    setActiveDropdownOnLoad() {
      this.menu.forEach((n, i) => {
        if (n.drop === 1) {
          const matchedSubmenu = n.submenu.find(
            (s) => s.url === this.$route.path
          );
          if (matchedSubmenu) {
            this.activeDropdown = i;
            this.$store.commit("Auth/SET_HEADERNAME", matchedSubmenu.name);
          }
        }
      });

      const directMenu = this.menu.find(
        (n) => n.drop !== 1 && n.url === this.$route.path
      );
      if (directMenu) {
        this.$store.commit("Auth/SET_HEADERNAME", directMenu.name);
      }
    },
    readAll(index, url) {
      if (index === 0) {
        index = 1
      }else if (index === 1) {
        index = 2
      }else if (index === 2) {
        index = 3
      }
      const currentPage = getPage();
      localStorage.setItem("lastMenuIndex", index);
      this.$store.commit("ImageProduct/SET_STATUS", index);
      this.$store.dispatch("ImageProduct/readAll", currentPage);
      // Periksa apakah URL tujuan berbeda dengan URL saat ini
      if (this.$route.path !== url) {
        this.$router.push({ path: url });
      }
    },
    
  },
};
</script>
<style scoped>
#sidebar {
  position: fixed;
  top: 0;
  left: 0;
  max-width: 240px;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgb(58, 136, 233) 0%,
    rgb(15, 70, 139) 100%
  );
  /* background-color: var(--bg-color); */
  overflow-y: auto;
  scrollbar-width: none;
  transition: all 0.3s ease;
  z-index: 200;
}
#sidebar.hide {
  max-width: 60px;
}
#sidebar.hide:hover {
  max-width: 240px;
}
#sidebar::-webkit-scrollbar {
  display: none;
}

/* =====SIDE HEADER / LOGO====== */
#sidebar .sideheader {
  position: sticky;
  box-shadow: 4px 4px 16px rgba(77, 76, 76, 0.1);
  top: 0;
  left: 0;
  z-index: 100;
  background: var(--bg-color);
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
#sidebar .sideheader .logo {
  padding: 3.1px 10px;
  text-align: center;
}
#sidebar .sideheader .logo .logo1 {
  width: 115px;
}
#sidebar .sideheader .logo .logo2 {
  width: 25px;
  /* transition: all 0.3s ease; */
}
#sidebar .closeSidebar {
  display: none;
  color: var(--text-one);
}
@media (max-width: 767.98px){
  #sidebar .sideheader {
    display: flex;
    align-items: center !important;
    justify-content: space-around;

  }
  #sidebar .closeSidebar {
    display: inline-block;
    color: var(--text-one);
  }
}
/* =====SIDE HEADER / LOGO====== */

/* =====SIDE MENU====== */
#sidebar .icon-left {
  min-width: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 6px;
}
#sidebar .icon-right {
  margin-left: auto;
  transition: all 0.3s ease;
  font-size: 10px;
  transform: rotateZ(-90deg);
}
#sidebar .side-menu {
  margin: 36px 0 !important;
  padding: 0 10px !important;
  transition: all 0.3s ease;
}
#sidebar .side-menu li {
  cursor: pointer;
}
#sidebar.hide .side-menu {
  padding: 0 6px !important;
}
#sidebar.hide:hover .side-menu {
  padding: 0 15px !important;
}
#sidebar .side-menu a {
  display: flex;
  align-items: center;
  font-size: 13px;
  /* color: var(--text-one); */
  color: #fff;
  padding: 10px 16px 10px 0 !important;
  transition: all 0.3s ease;
  border-radius: 6px;
  margin: 3px 0 !important;
  white-space: nowrap;
  text-transform: capitalize;
  border-bottom: 1px solid rgba(255, 255, 255, 0.349);
}
#sidebar .side-menu > li > a:hover {
  background: var(--hover-one);
  color: var(--text-one);
}
#sidebar .side-menu > li > a.menu-active .icon-right {
  transform: rotateZ(0deg);
  transition: transform 0.3s ease;
}
#sidebar .side-menu > li > a.menu-active,
#sidebar .side-menu > li > a.menu-active:hover {
  /* background: linear-gradient(
    90deg,
    rgb(58, 136, 233) 0%,
    rgb(15, 70, 139) 100%
  ); */
  background: var(--hover-one);
  color: var(--text-one);
}
/* =====SIDE MENU====== */

/* =====SIDE DROPDOWN====== */
#sidebar .icon-left-side {
  min-width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 6px;
}
#sidebar .side-dropdown {
  padding-left: 28px !important;
  max-height: 0 !important;
  overflow-y: hidden;
  transition: all 0.15s ease;
}
#sidebar .side-dropdown.show {
  max-height: 1000px !important;
}
#sidebar.hide .side-dropdown.show {
  max-height: 0 !important;
}
#sidebar.hide:hover .side-dropdown.show {
  max-height: 1000px !important;
}
#sidebar .side-dropdown.show a:hover {
  color: var(--text-three);
}
#sidebar .side-dropdown.show a.side-active {
  color: var(--text-two);
}
/* =====SIDE DROPDOWN====== */

/* =====SIDE DIVIDERS====== */
#sidebar .dividers {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 600;
  color: var(--text-one);
  transition: all 0.3s ease;
  white-space: nowrap;
}
#sidebar.hide:hover .dividers {
  text-align: left;
}
#sidebar.hide .dividers {
  text-align: center;
}
/* =====SIDE DIVIDERS====== */

/* STYLE MOBILE DEVICE  */
/* @media (max-width: 576px) {
  #sidebar.hide {
    max-width: 0%;
  }
  #sidebar {
    max-width: 100%;
  }
  #sidebar .closeSidebar {
    display: block;
    color: var(--text-one);
  }
  .sideheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
  }
} */
/* STYLE MOBILE DEVICE  */
</style>
